import { gql } from "@apollo/client";

export const GET_USER_PROFILE = gql`
  query GetUserProfile($id: ID!) {
    user(id: $id) {
      id
      username
      email
      phone
      address
      city
      state
      country
      zipcode
      desc
      defaultBusinessId
      defaultPageId
      timeZone {
        id
        timezone
      }
    }
  }
`;

export const GET_AGENT_USERS = gql`
  query GetAgentUsers($includeInactive: Boolean = false) {
    agentUsers(includeInactive: $includeInactive) {
      id
      username
      email
      phone
      address
      city
      state
      country
      zipcode
      status
      isAgent
      isPlatformAdmin
      isDefaultConcierge
    }
  }
`;

export const GET_AGENT_APPLICATIONS = gql`
  query GetAgentApplications($statuses: [String!], $limit: Int, $offset: Int) {
    agentApplications(statuses: $statuses, limit: $limit, offset: $offset) {
      id
      applicantUserId
      email
      username
      phone
      address
      city
      state
      country
      zipcode
      serviceAreas
      specialties
      notes
      status
      reviewedByUserId
      reviewedAt
      reviewNotes
      approvedUserId
      createdAt
      updatedAt
      reviewedBy {
        id
        username
        email
      }
      approvedUser {
        id
        username
        email
      }
    }
  }
`;
